module.exports = __webpack_public_path__ + "img/ranking-bg-1.d3a8a09.png";